module.exports = __webpack_public_path__ + "static/media/author.a4b9d955.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/author.png
// module id = 135
// module chunks = 0